import { render, staticRenderFns } from "./car-scheme-suv-hatch-svg.vue?vue&type=template&id=37a7df59&scoped=true"
import script from "./car-scheme-suv-hatch-svg.vue?vue&type=script&lang=js"
export * from "./car-scheme-suv-hatch-svg.vue?vue&type=script&lang=js"
import style0 from "./car-scheme-suv-hatch-svg.vue?vue&type=style&index=0&id=37a7df59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a7df59",
  null
  
)

export default component.exports